import React from 'react';
import Message from "./shared/message/Message";
import PageWrapper from "./shared/pagewrapper/PageWrapper";

export default function PageNaoEncontrada() {
    return (
        <PageWrapper>
            <Message type='warning'>Página não encontrada!</Message>
        </PageWrapper>
    );
};